import { Amplify } from 'aws-amplify';

export interface AuthEnv {
  userPoolId: string;
  userPoolClientId: string;
  region: string;
}

const env: AuthEnv = {
  userPoolId: import.meta.env.VITE_USER_POOL_ID ?? '',
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '',
  region: import.meta.env.VITE_AWS_REGION ?? 'us-west-2',
};

export const authConfigured = Boolean(env.userPoolId && env.userPoolClientId);
export const devAuth =
  import.meta.env.DEV && import.meta.env.VITE_DEV_AUTH === 'true'
    ? {
        email: import.meta.env.VITE_DEV_AUTH_EMAIL ?? 'dev-admin@example.com',
        groups: (import.meta.env.VITE_DEV_AUTH_GROUPS ?? 'admin')
          .split(',')
          .map((group) => group.trim())
          .filter(Boolean),
      }
    : undefined;

if (authConfigured) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.userPoolId,
        userPoolClientId: env.userPoolClientId,
      },
    },
  });
} else if (import.meta.env.DEV && !devAuth) {
  // eslint-disable-next-line no-console
  console.info(
    '[auth] VITE_USER_POOL_ID / VITE_USER_POOL_CLIENT_ID not set — auth disabled in dev. Sign-in UI will show a stub.',
  );
}
